



















import { Component, Prop } from "vue-property-decorator";

import { ValidationMessage, BaseInputComponent } from ".";
import LabelWithTooltip from "./LabelWithTooltip.vue";

@Component({
  components: {
    ValidationMessage,
    LabelWithTooltip,
  },
})
export default class InputDate extends BaseInputComponent {
  @Prop({ default: "HH:mm" }) valueFormat: string;
  @Prop() pickerOptions?: any;
}
